import React from "react";
import { createRoot } from "react-dom/client";
import locale from "antd/lib/locale/mn_MN";
import { ConfigProvider } from "antd";
import "./styles/index.css";
import "./styles/antd.less";
import { App } from "./containers";
import { GlobalProvider } from "./context";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import dayjs from "dayjs";

const { search } = window.location;
if (new URLSearchParams(search).has("deviceType")) {
  localStorage.setItem(
    "deviceType",
    new URLSearchParams(search).get("deviceType")
  );
} else {
  localStorage.setItem("deviceType", null);
}

var duration = require("dayjs/plugin/duration");
dayjs.extend(duration);

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  
  <BrowserRouter>
    <GlobalProvider>
      <ConfigProvider
        locale={locale}
        theme={{
          token: {
            colorPrimary: "#162654",
          },
        }}
      > 
        <App />
        <Toaster position="top-right" toastOptions={{ duration: 3000 }} />
      </ConfigProvider>
    </GlobalProvider>
  </BrowserRouter>,
  document.getElementById("root")
);
serviceWorker.register();
reportWebVitals();
